import Header from "../disenrollment/components/Header";
import {SpinnerBasic} from "./Spinner-basic";
import React from 'react';
import {Jumbotron} from "reactstrap";

function UnderConstruction(props) {

  const styleObj = {backgroundColor: 'white'};

  const renderBody = () => {
    return (<>
        <div id='main-body' style={{backgroundColor: '#dcdcdc30'}}>
          <Header style={styleObj}/>
          <div className="content container" id={"content"} style={{marginTop: '42px'}}>
            <Jumbotron id={"apologiesJumbotron"}>
              <h1 className="display-3">Our Apologies...</h1>
              <p className="lead">The form for disenrolling or transferring members is currently under construction.</p>
              <hr className="my-2"/>
              <p>We apologize for the inconvenience while we are improving the system. Please send in
                your request by fax or email.  Thanks for your patience.</p>
            </Jumbotron>
          </div>
          <footer className="no-print footer" data-html2canvas-ignore="true">
            <div id="pe-footer" className="text-center">
              Complete Personal and Direct Care
              PO Box 3630
              Little Rock, AR 72202
              Toll-free: 1-866-423-0415 (TTY 711)
            </div>
          </footer>
          <footer className="print-footer text-center">Complete Personal and Direct Care PO Box 3630 Little Rock, AR
            72202 Toll-free: 1-866-423-0415 (TTY 711)
          </footer>
        </div>
      </>
    );
  }

  return (
    <div className="main-page print">
      {props.loading === true
        ? <SpinnerBasic/>
        : renderBody()}
    </div>
  );
}

export default UnderConstruction;